import React from 'react';

const LoadableState = ({
  speed = 300,
  opacity = 0.4,
  loading = false,
  className = '',
  children,
}) => {
  const transition = `opacity ${speed}ms ease`;
  const style = {
    WebkitTransition: transition,
    transition,
    opacity: loading ? opacity : 1,
  };

  return (
    <div style={style} className={`LoadableState ${className}`}>
      {children}
    </div>
  );
};

export default LoadableState;
